// SOX Audit swimlanes configuration
// Option 1: Control testing flow (DEFAULT)
export const DEMO_SWIMLANES = [
  {label: "Business Process", color: "#3182CE", minX: -2, maxX: 8}, // Blue
  {label: "Key Controls", color: "#38A169", minX: 8, maxX: 18}, // Green
  {label: "Testing & Evidence", color: "#9F7AEA", minX: 18, maxX: 28}, // Purple
  {label: "Management Review", color: "#DD6B20", minX: 28, maxX: 38}, // Orange
] as const;

// Alternative SOX swimlane configurations:
// Uncomment the option you want to use and comment out the default above

// Option 2: Full control lifecycle phases
// export const DEMO_SWIMLANES = [
//   {label: "Identify Risks", color: "#3182CE", minX: -2, maxX: 7},
//   {label: "Design Controls", color: "#38A169", minX: 7, maxX: 14},
//   {label: "Test Effectiveness", color: "#9F7AEA", minX: 14, maxX: 21},
//   {label: "Report Deficiencies", color: "#DD6B20", minX: 21, maxX: 28},
//   {label: "Remediate", color: "#E53E3E", minX: 28, maxX: 35},
// ] as const;

// Option 3: Financial close process
// export const DEMO_SWIMLANES = [
//   {label: "Transaction Processing", color: "#3182CE", minX: -2, maxX: 10},
//   {label: "Account Reconciliation", color: "#38A169", minX: 10, maxX: 20},
//   {label: "Financial Reporting", color: "#9F7AEA", minX: 20, maxX: 30},
//   {label: "External Audit", color: "#DD6B20", minX: 30, maxX: 40},
// ] as const;

// Option 4: IT General Controls (ITGC) flow
// export const DEMO_SWIMLANES = [
//   {label: "Access Controls", color: "#3182CE", minX: -2, maxX: 8},
//   {label: "Change Management", color: "#38A169", minX: 8, maxX: 16},
//   {label: "Backup & Recovery", color: "#9F7AEA", minX: 16, maxX: 24},
//   {label: "Monitoring & Logging", color: "#DD6B20", minX: 24, maxX: 32},
// ] as const;

// Option 5: Audit phases
// export const DEMO_SWIMLANES = [
//   {label: "Planning & Scoping", color: "#3182CE", minX: -2, maxX: 8},
//   {label: "Fieldwork & Testing", color: "#38A169", minX: 8, maxX: 16},
//   {label: "Evaluation & Findings", color: "#9F7AEA", minX: 16, maxX: 24},
//   {label: "Reporting & Certification", color: "#DD6B20", minX: 24, maxX: 32},
// ] as const;
